// Currency utility functions

export const CURRENCIES = {
  GBP: { symbol: '£', code: 'GBP', name: 'British Pound' },
  USD: { symbol: '$', code: 'USD', name: 'US Dollar' },
  EUR: { symbol: '€', code: 'EUR', name: 'Euro' },
  SGD: { symbol: 'S$', code: 'SGD', name: 'Singapore Dollar' },
  AUD: { symbol: 'A$', code: 'AUD', name: 'Australian Dollar' },
  CAD: { symbol: 'C$', code: 'CAD', name: 'Canadian Dollar' },
  JPY: { symbol: '¥', code: 'JPY', name: 'Japanese Yen' },
  CHF: { symbol: 'CHF', code: 'CHF', name: 'Swiss Franc' },
  INR: { symbol: '₹', code: 'INR', name: 'Indian Rupee' },
  MYR: { symbol: 'RM', code: 'MYR', name: 'Malaysian Ringgit' }
};

export const DEFAULT_CURRENCY = 'GBP';

export function formatCurrency(amount, currencyCode = DEFAULT_CURRENCY) {
  const currency = CURRENCIES[currencyCode] || CURRENCIES[DEFAULT_CURRENCY];
  return `${currency.symbol}${Number(amount).toFixed(2)}`;
}

export function getCurrencySymbol(currencyCode = DEFAULT_CURRENCY) {
  const currency = CURRENCIES[currencyCode] || CURRENCIES[DEFAULT_CURRENCY];
  return currency.symbol;
}

export function getCurrencyOptions() {
  return Object.entries(CURRENCIES).map(([code, currency]) => ({
    value: code,
    label: `${currency.symbol} ${currency.name}`,
    symbol: currency.symbol
  }));
}
